/**
 * Mock data for marketplace MVP
 * This seeds the localStorage with demo data
 */

import { setStorageItem, getStorageItem } from '../utils/storage';

// Demo users
const demoUsers = [
  {
    id: 'farmer_demo_sarah',
    name: 'Sarah Mitchell',
    email: 'sarah@prairiefarms.ca',
    phone: '306-555-0123',
    user_type: 'farmer',
    business_name: 'Prairie Fresh Farms',
    created_at: '2024-01-15T10:00:00.000Z'
  },
  {
    id: 'farmer_demo_marcus',
    name: 'Marcus Chen',
    email: 'marcus@sunriseacres.ca',
    phone: '306-555-0456',
    user_type: 'farmer',
    business_name: 'Sunrise Acres',
    created_at: '2024-01-20T10:00:00.000Z'
  },
  {
    id: 'restaurant_demo_emily',
    name: 'Emily Rodriguez',
    email: 'emily@downtownbistro.ca',
    phone: '306-555-0789',
    user_type: 'restaurant',
    business_name: 'Downtown Bistro',
    created_at: '2024-02-01T10:00:00.000Z'
  },
  {
    id: 'restaurant_demo_james',
    name: 'James Wilson',
    email: 'james@theharvest.ca',
    phone: '306-555-0321',
    user_type: 'restaurant',
    business_name: 'The Harvest Kitchen',
    created_at: '2024-02-05T10:00:00.000Z'
  }
];

// Demo listings
const demoListings = [
  {
    id: 'listing_demo_1',
    farmer_id: 'farmer_demo_sarah',
    farmer_name: 'Prairie Fresh Farms',
    item_name: 'Roma Tomatoes',
    category: 'Vegetables',
    quantity: 200,
    unit: 'kg',
    price: 3.50,
    photo_url: 'https://images.unsplash.com/photo-1546470427-227c7369a9e6?w=400&h=300&fit=crop',
    description: 'Fresh, vine-ripened Roma tomatoes. Perfect for sauces and salads. Picked this week.',
    status: 'active',
    created_at: '2024-12-10T10:00:00.000Z'
  },
  {
    id: 'listing_demo_2',
    farmer_id: 'farmer_demo_sarah',
    farmer_name: 'Prairie Fresh Farms',
    item_name: 'Sweet Corn',
    category: 'Vegetables',
    quantity: 500,
    unit: 'crates',
    price: 25.00,
    photo_url: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=400&h=300&fit=crop',
    description: 'Peaches and cream variety. Exceptionally sweet. Available for bulk orders.',
    status: 'active',
    created_at: '2024-12-09T14:00:00.000Z'
  },
  {
    id: 'listing_demo_5',
    farmer_id: 'farmer_demo_sarah',
    farmer_name: 'Prairie Fresh Farms',
    item_name: 'Fresh Basil',
    category: 'Herbs',
    quantity: 50,
    unit: 'bunches',
    price: 3.00,
    photo_url: 'https://images.unsplash.com/photo-1618375569909-3c8616cf7733?w=400&h=300&fit=crop',
    description: 'Aromatic sweet basil. Greenhouse grown for year-round availability.',
    status: 'active',
    created_at: '2024-12-06T15:00:00.000Z'
  },
  {
    id: 'listing_demo_6',
    farmer_id: 'farmer_demo_marcus',
    farmer_name: 'Sunrise Acres',
    item_name: 'Honeycrisp Apples',
    category: 'Fruits',
    quantity: 300,
    unit: 'kg',
    price: 4.50,
    photo_url: 'https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=400&h=300&fit=crop',
    description: 'Crisp and sweet. Cold storage maintained for optimal freshness.',
    status: 'active',
    created_at: '2024-12-05T08:00:00.000Z'
  },
  {
    id: 'listing_demo_7',
    farmer_id: 'farmer_demo_sarah',
    farmer_name: 'Prairie Fresh Farms',
    item_name: 'Butternut Squash',
    category: 'Vegetables',
    quantity: 150,
    unit: 'units',
    price: 2.75,
    photo_url: 'https://images.unsplash.com/photo-1570586437263-ab629fccc818?w=400&h=300&fit=crop',
    description: 'Sweet, nutty flavor. Perfect for soups and roasting. Medium to large sizes.',
    status: 'active',
    created_at: '2024-12-04T12:00:00.000Z'
  },
];

// Demo conversations
const demoConversations = [
  {
    id: 'conv_demo_1',
    listing_id: 'listing_demo_1',
    listing_name: 'Roma Tomatoes',
    farmer_id: 'farmer_demo_sarah',
    farmer_name: 'Prairie Fresh Farms',
    restaurant_id: 'restaurant_demo_emily',
    restaurant_name: 'Downtown Bistro',
    updated_at: '2024-12-10T14:30:00.000Z',
    last_message: 'Perfect, I can deliver tomorrow morning...'
  }
];

// Demo messages
const demoMessages = [
  {
    id: 'msg_demo_1',
    conversation_id: 'conv_demo_1',
    sender_id: 'restaurant_demo_emily',
    sender_name: 'Downtown Bistro',
    sender_type: 'restaurant',
    content: 'Hi! I\'m interested in your Roma tomatoes. Do you have 50kg available for this weekend?',
    timestamp: '2024-12-10T14:00:00.000Z'
  },
  {
    id: 'msg_demo_2',
    conversation_id: 'conv_demo_1',
    sender_id: 'farmer_demo_sarah',
    sender_name: 'Prairie Fresh Farms',
    sender_type: 'farmer',
    content: 'Hello! Yes, we have plenty available. 50kg is no problem. Would you like them delivered or will you pick up?',
    timestamp: '2024-12-10T14:15:00.000Z'
  },
  {
    id: 'msg_demo_3',
    conversation_id: 'conv_demo_1',
    sender_id: 'restaurant_demo_emily',
    sender_name: 'Downtown Bistro',
    sender_type: 'restaurant',
    content: 'Delivery would be great if possible. We\'re at 123 Main Street, downtown Regina.',
    timestamp: '2024-12-10T14:20:00.000Z'
  },
  {
    id: 'msg_demo_4',
    conversation_id: 'conv_demo_1',
    sender_id: 'farmer_demo_sarah',
    sender_name: 'Prairie Fresh Farms',
    sender_type: 'farmer',
    content: 'Perfect, I can deliver tomorrow morning around 9am. The total would be $175 for 50kg. Does that work for you?',
    timestamp: '2024-12-10T14:30:00.000Z'
  }
];

/**
 * Initialize marketplace with demo data
 * Only seeds data if it doesn't already exist
 */
export const initializeMarketplaceData = () => {
  // Check if data already exists
  const existingUsers = getStorageItem('marketplace_users', []);
  const existingListings = getStorageItem('listings', []);

  // Only seed if no users exist (first time)
  if (existingUsers.length === 0) {
    setStorageItem('marketplace_users', demoUsers);
    console.log('Marketplace users seeded');
  }

  if (existingListings.length === 0) {
    setStorageItem('listings', demoListings);
    console.log('Marketplace listings seeded');
  }

  // Only seed conversations if none exist
  const existingConversations = getStorageItem('conversations', []);
  if (existingConversations.length === 0) {
    setStorageItem('conversations', demoConversations);
    setStorageItem('messages', demoMessages);
    console.log('Marketplace conversations seeded');
  }
};

/**
 * Reset marketplace data to initial demo state
 * Useful for demos and testing
 */
export const resetMarketplaceData = () => {
  setStorageItem('marketplace_users', demoUsers);
  setStorageItem('listings', demoListings);
  setStorageItem('conversations', demoConversations);
  setStorageItem('messages', demoMessages);
  setStorageItem('marketplace_user', null);
  setStorageItem('marketplace_auth', null);
  console.log('Marketplace data reset to demo state');
};

/**
 * Get demo credentials for display
 */
export const getDemoCredentials = () => ({
  farmer: {
    email: 'sarah@prairiefarms.ca',
    password: 'demo123',
    name: 'Prairie Fresh Farms'
  },
  restaurant: {
    email: 'emily@downtownbistro.ca',
    password: 'demo123',
    name: 'Downtown Bistro'
  }
});

export { demoUsers, demoListings, demoConversations, demoMessages };
